import classNames from 'classnames';
import { Link } from 'react-router-dom';

import ErrorIcon from '../../../assets/images/icon-filled-alert-exclamation-circle.svg';
import WarningIcon from '../../../assets/images/icon-filled-alert-exclamation.svg';
import InfoIcon from '../../../assets/images/icon-filled-alert-info.svg';
import SuccessIcon from '../../../assets/images/icon-filled-success-tick.svg';

export interface Props {
  alertType: 'info' | 'warning' | 'error' | 'success';
  title?: string;
  body?: string | React.ReactNode;
  href?: string;
  className?: string;
}

const Alert = ({ alertType, title, body, href, className }: Props) => {
  let alertProps: { containerClassName: string; icon: string; textColor: string };
  switch (alertType) {
    case 'info':
      alertProps = { containerClassName: 'bg-blue-100 border-blue-600', icon: InfoIcon, textColor: 'text-blue-500' };
      break;
    case 'warning':
      alertProps = {
        containerClassName: 'bg-yellow-100 border-yellow-600',
        icon: WarningIcon,
        textColor: 'text-yellow-700',
      };
      break;
    case 'error':
      alertProps = { containerClassName: 'bg-red-100 border-red-600', icon: ErrorIcon, textColor: 'text-red-500' };
      break;
    case 'success':
      alertProps = {
        containerClassName: 'bg-green-100 border-green-400',
        icon: SuccessIcon,
        textColor: 'text-green-500',
      };
      break;
  }

  return (
    <div
      role="alert"
      className={classNames(
        'flex flex-row items-start gap-x-3 rounded-xl border px-6 py-5',
        className,
        alertProps.containerClassName
      )}
    >
      <div className="w-5 flex-initial shrink-0 basis-5">
        <img src={alertProps.icon} alt={title} className="h-5 w-5" />
      </div>
      <div className="flex flex-col items-start gap-y-2">
        {!!title && <p className={classNames('text-base font-semibold', alertProps.textColor)}>{title}</p>}
        {!!body &&
          (typeof body === 'string' ? (
            <p className={classNames(alertProps.textColor)}>{body}</p>
          ) : (
            <div className={alertProps.textColor}>{body}</div>
          ))}
        {!!href && (
          <div>
            <Link to={href} className={classNames(alertProps.textColor, 'text-base font-medium underline')}>
              Review session fee policy
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Alert;
